import { render, staticRenderFns } from "./itinerary-day.vue?vue&type=template&id=fdddf192&"
import script from "./itinerary-day.vue?vue&type=script&lang=js&"
export * from "./itinerary-day.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports